import { IConfiguredHttp } from './http';

export interface IRentalsunitedCurrencyApi {

	getRentalsunitedCurrency(rentalsunitedBookingId: string | number, currency?: string): Promise<{ updated_currency: string }>;
}

const rentalsunitedCurrencyApiFactory = (http: IConfiguredHttp, prefix = ''): IRentalsunitedCurrencyApi => ({
	async getRentalsunitedCurrency(rentalsunitedBookingId, currency?) {
		const response = await http.get(`${prefix}/${rentalsunitedBookingId}${currency ? '?currency=' + currency : ''}`);
		if (!response) {
			throw new Error('Unable to update currency');
		}

		return response;
	}
});

export default rentalsunitedCurrencyApiFactory;
